<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/driver/information-queue" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Trip</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="top-informations">
      <div class="value-bigger">
        <span>Trip Amount</span>
        <span style="color: black;">{{ race.valorCorrida | currency }}</span>
      </div>
      <div class="data-user">
        <div class="block">
          <div class="ico">
            <ion-img src="assets/user.png" />
          </div>
          <h3>{{ race.nomePassageiro }}</h3>
        </div>
        <p class="detail" style="color: black;"><ion-icon name="call"></ion-icon> {{ race.celular }}</p>
        <div class="payment-badge">
          <ion-badge color="primary" *ngIf="race?.pagaPelaPlataforma">Paid by Platform</ion-badge>
          <ion-badge color="success" *ngIf="!race?.pagaPelaPlataforma">Collect from Passenger</ion-badge>
        </div>
      </div>
    </div>
  <div class="informations-complementary">
    <div class="block full one green" *ngIf="!race.raceType.includes('Round Trip')">
      <h4>Origin</h4>
      <p><ion-icon name="pin"></ion-icon> {{ race.enderecoOrigem }}</p>
    </div>
    <div class="block full one green" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
      <h4>Origin</h4>
      <p><ion-icon name="pin"></ion-icon> {{ race.enderecoOrigem }}</p>
    </div>
    <div class="block full one green" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 1">
      <h4>Origin</h4>
      <p><ion-icon name="pin"></ion-icon> {{ race.enderecoDestino }}</p>
    </div>
    <div class="block full one blue" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 1">
      <h4>Destination</h4>
      <p><ion-icon name="pin"></ion-icon> {{ race.enderecoOrigem }}</p>
    </div>
    <div class="block full one blue" *ngIf="!race.raceType.includes('Round Trip')">
      <h4>Destination</h4>
      <p><ion-icon name="pin"></ion-icon> {{ race.enderecoDestino }}</p>
    </div>
    <div class="block full one blue" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
      <h4>Destination</h4>
      <p><ion-icon name="pin"></ion-icon> {{ race.enderecoDestino }}</p>
    </div>
  </div>
  <div class="buttons-locations" *ngIf="!race.raceType.includes('Round Trip')">
    <button class="button-location" (click)="navigate('Maps')">
      <ion-img src="assets/images/ico-gmaps.png" class="ico" />
      Google Maps
    </button>
    <button class="button-location" (click)="navigate('Waze')">
      <ion-img src="assets/images/ico-waze.png" class="ico" />
      Waze
    </button>
  </div>
  <div class="buttons-locations" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
    <button class="button-location" (click)="navigate('Maps')">
      <ion-img src="assets/images/ico-gmaps.png" class="ico" />
      Google Maps
    </button>
    <button class="button-location" (click)="navigate('Waze')">
      <ion-img src="assets/images/ico-waze.png" class="ico" />
      Waze
    </button>
  </div>
  <div class="buttons-locations" *ngIf="race.etapaIdaVolta && race.etapaIdaVolta === 1">
    <button class="button-location" (click)="navigateRoundTripReturn('Maps')">
      <ion-img src="assets/images/ico-gmaps.png" class="ico" />
      Google Maps
    </button>
    <button class="button-location" (click)="navigateRoundTripReturn('Waze')">
      <ion-img src="assets/images/ico-waze.png" class="ico" />
      Waze
    </button>
  </div>
  <div class="informations-complementary no-margin">
    <div class="block" *ngIf="!race.raceType.includes('Round Trip')">
      <h4>Trip</h4>
      <p><ion-icon name="contract"></ion-icon> {{ race.raceType }}</p>
    </div>
    <div class="block" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
      <h4>Trip</h4>
      <p><ion-icon name="contract"></ion-icon> {{ race.raceType }}</p>
    </div>
    <div class="block" *ngIf="!race.raceType.includes('Round Trip')">
      <h4>Transfer to GoSpread</h4>
      <p>
        <ion-icon name="cash"></ion-icon> {{ race.repasseMotorista | currency }}
      </p>
    </div>
    <div class="block" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
      <h4>Transfer to GoSpread</h4>
      <p>
        <ion-icon name="cash"></ion-icon> {{ race.repasseMotorista | currency }}
      </p>
    </div>
    <div class="block full one" *ngIf="race.raceType.includes('Round Trip') && race.etapaIdaVolta === 0">
      <h4>Trip Comments</h4>
      <p><ion-icon name="chatbox"></ion-icon> {{ race.observation }}</p>
    </div>
    <div class="block full one" *ngIf="!race.raceType.includes('Round Trip')">
      <h4>Trip Comments</h4>
      <p><ion-icon name="chatbox"></ion-icon> {{ race.observation }}</p>
    </div>
  </div>
  <footer class="ion-padding">
    <button *ngIf="isToday()" class="button-bigger grey" (click)="startRace()">
      <span class="decoration-primary">Start Trip</span>
    </button>
    <p *ngIf="!isToday()" class="schedule-note">
      Trip scheduled for {{ race.dataAgendamentoCorrida | date:'mediumDate' }}.
      The Start button is enabled on the day of the ride.
    </p>

    <button class="button-outline" (click)="cancelRace()">Cancel</button>
  </footer>

  <div *ngIf="isOpenCanceling" class="container-comment" [ngClass]="{ open: isOpenCanceling }">
    <form [formGroup]="formCancelation">
      <h3>
        <ion-icon name="chatbox"></ion-icon>
        Please state the reason for the cancellation
      </h3>

      <div class="container">
        <input formControlName="motivoCancelamento" type="text" class="input" placeholder="Insert your reason" />
        <ion-button shape="round" size="small" (click)="postReason()"
          [disabled]="formCancelation.invalid">Send</ion-button>
      </div>
    </form>
  </div>
</ion-content>